import { createTheme } from "@mui/material";
import { baseTheme } from "./base";

const customComponents = {
	AppFooter: {
		backgroundColor: 'gainsboro',
		borderTop: '1px solid #BDBDBD'
	}
}

export const defaultTheme = createTheme({
	palette: {
		background: {
			// default: '#F5F5F5' // App background
			default: '#2C6562' // App background
		},
		primary: {
			main: '#BDBDBD',
			text: '#212121'
		}
	},
	typography: ({theme}) =>  ({
		fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
		welcome: {
			fontWeight: 600,
			fontSize: '2.125rem',
			lineHeight: '1.235',
			// color: theme.palette.primary.text
		},
		title: {
			fontWeight: 600,
			fontSize: '1.425rem',
			lineHeight: '1.235',
			// color: theme.palette.primary.text
		},
		title2: {
			margin: 0,
			fontWeight: 400,
			fontSize: '1rem',
			lineHeight: 1.35,
		},
		subtitle: {
			margin: 0,
			fontWeight: 600,
			fontSize: '1.1rem',
			lineHeight: 1.35,
			marginTop: '12px'
			// color: theme.palette.primary.text
		},
		subtitle2: {
			margin: 0,
			fontWeight: 400,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px'
			// color: theme.palette.primary.text
		},
		text: {
			margin: 0,
			fontWeight: 400,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px'
		},
		text_success: {
			margin: 0,
			fontWeight: 400,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px',
		}
	}),
	components: {
		MuiAppBar: {
			defaultProps: {
				elevation: 0
			}
		},
		MuiButton: {
			defaultProps: {
				disableElevation: true
			},
			styleOverrides: {	
				root: {
					fontSize: '1rem',
					fontWeight: 600,
					textTransform: 'unset',
					"&.Mui-disabled": {
						"opacity": 0.4
					}
				},
				sizeLarge: { // Increase button's height
					paddingTop: '12px',
					paddingBottom: '12px',
				}
			}
		}
	},
}, baseTheme, customComponents);